import { render, staticRenderFns } from "./sample-descriptions.vue?vue&type=template&id=aa4c3958&scoped=true&"
import script from "./sample-descriptions.vue?vue&type=script&lang=js&"
export * from "./sample-descriptions.vue?vue&type=script&lang=js&"
import style0 from "./sample-descriptions.vue?vue&type=style&index=0&id=aa4c3958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4c3958",
  null
  
)

export default component.exports